export default "__VITE_ASSET__CVR$En1t__"